import React from 'react'
import Modal from 'react-modal'
import {useError} from "../../hooks"

export default function MyPopup(props) {
  //const{popOpen,setPopOpen}=useError();
 // const [isOpen, setIsOpen] = React.useState(false)
  const {titulo,contenido}=props;

  return (
    <div>
      {/* <button onClick={() => setIsOpen(true)}>Open Popup</button> */}
      {/* <Modal ariaHideApp={false} isOpen={popOpen} onRequestClose={() => setPopOpen(false)}>
        <h1>{titulo}</h1>
        <p>{contenido}</p>
        <button onClick={() => setPopOpen(false)}>Close Popup</button>
      </Modal> */}
    </div>
  )
}






